import {
  text,
  tac,
  pcHidden
} from './style'
import { Spacer } from 'components/Spacer'
import { Icon } from 'icons/Icon'

export const SystemError = () => {
  return (
    <div className={tac}>
      <Icon name="Cry" size={44} />
      <Spacer size={17}/>
      <p className={text}>
        申し訳ありません。<br />
        現在、Stageはアクセスできない<br className={pcHidden}/>
        状態になっています。<br />
        時間をおいて再度アクセスしてください。
      </p>
    </div>
  );
}

